import styled from 'styled-components';
import SbSelect from 'uiCore/SbSelect/SbSelect';


export const PageWrapperStyled = styled.div`
  padding: 32px 40px;
  background: ${p => p.theme?.colors?.light ?? '#F7F7F7'};
  min-height: 100%;
`;

export const FullWidthSelectStyled = styled(SbSelect)`
  width: 100%;
`;
